/* crashGuard — شبكة أمان عامة ضد الشاشة البيضاء وحلقات إعادة التحميل.
 *
 * 1. يلتقط أخطاء تحميل الـ chunks (بعد نشر جديد) من أي مكان (render أو
 *    event handlers أو dynamic import) ويعالجها بمسح كاش الـ SW ثم إعادة
 *    تحميل واحدة محروسة — بدل ترك المستخدم على صفحة بيضاء.
 * 2. حارس ضد حلقات إعادة التحميل: حدّ أقصى إعادتا تحميل في الدقيقة.
 */

export const CHUNK_ERR_RE = /Loading chunk|ChunkLoadError|dynamically imported module|Importing a module script failed|Failed to fetch dynamically|error loading dynamically imported|Unexpected token '<'/i;

export function isChunkError(err) {
  return CHUNK_ERR_RE.test(String((err && err.message) || err || ""));
}

/** مسح كاش الـ Service Worker ثم إعادة تحميل محروسة.
 *  ترجع false إذا استُنفد الحد (لا إعادة تحميل) ليُعرض زر يدوي بدلاً منها. */
export async function purgeCachesAndReload() {
  const now = Date.now();
  let hist = [];
  try {
    hist = JSON.parse(sessionStorage.getItem("rg_reload_hist") || "[]")
      .filter((t) => now - t < 60_000);
  } catch { hist = []; }
  if (hist.length >= 2) return false; // حارس حلقة إعادة التحميل
  hist.push(now);
  try { sessionStorage.setItem("rg_reload_hist", JSON.stringify(hist)); } catch { /* noop */ }
  try {
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  } catch { /* noop */ }
  try {
    const regs = await (navigator.serviceWorker?.getRegistrations?.() || Promise.resolve([]));
    regs.forEach((r) => { try { r.update(); } catch { /* noop */ } });
  } catch { /* noop */ }
  window.location.reload();
  return true;
}

/** إعادة تحميل يدوية قسرية (زر المستخدم) — تتجاوز الحارس وتمسح الكاش. */
export async function hardRecover() {
  try { sessionStorage.removeItem("rg_reload_hist"); } catch { /* noop */ }
  try {
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  } catch { /* noop */ }
  window.location.reload();
}

export function installCrashGuard() {
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e?.reason;
    if (isChunkError(reason)) {
      e.preventDefault();
      purgeCachesAndReload();
    }
  });
  window.addEventListener("error", (e) => {
    if (isChunkError(e?.message || e?.error)) purgeCachesAndReload();
  });
}
